// extracted by mini-css-extract-plugin
export default {"feedback":"Feedback_feedback__PHdSS","icon":"Feedback_icon__dJMLJ","text":"Feedback_text__DGS9q","btn":"Feedback_btn__YzHck"};